const KL_SELLING_FAST_SELECTOR = '[data-kl-selling-fast]';
const KL_SELLING_FAST_STORAGE_KEY = 'kl:selling-fast';
const KL_SELLING_FAST_MAX_TRACKED = 100;
const KL_SELLING_FAST_DEFAULT_SECONDS = 5;
const KL_SELLING_FAST_VISIBLE_CLASS = 'is-visible';

const KL_SELLING_FAST_LEAVING_CLASS = 'is-leaving';

function parseDuration(rawSeconds) {
  const seconds = Number.parseFloat(rawSeconds);

  return (Number.isFinite(seconds) && seconds > 0 ? seconds : KL_SELLING_FAST_DEFAULT_SECONDS) * 1000;
}

function getProductPosition(state, productId) {
  const seen = Array.isArray(state.viewed) ? state.viewed.map(String) : [];
  const storedCount = Number(state.count);
  const count = Number.isFinite(storedCount) && storedCount >= seen.length ? storedCount : seen.length;
  const existingIndex = seen.indexOf(String(productId));

  if (existingIndex !== -1) {
    return { position: count - seen.length + existingIndex + 1, viewedIds: seen, count };
  }

  const updated = [...seen, String(productId)].slice(-KL_SELLING_FAST_MAX_TRACKED);

  return { position: count + 1, viewedIds: updated, count: count + 1 };
}

function getIsBadgeDue(position, shownIds, productId) {
  if (position % 2 !== 1) return false;

  return !(Array.isArray(shownIds) ? shownIds.map(String) : []).includes(String(productId));
}

function getStore(scope) {
  try {
    const store = scope === 'local' ? localStorage : sessionStorage;
    const probeKey = `${KL_SELLING_FAST_STORAGE_KEY}:probe`;

    store.setItem(probeKey, '1');
    store.removeItem(probeKey);

    return store;
  } catch (error) {
    console.debug('kl-selling-fast: browser storage is unavailable, so no badge is shown', { scope, error });
    return null;
  }
}

function readState(store) {
  try {
    const parsed = JSON.parse(store.getItem(KL_SELLING_FAST_STORAGE_KEY) || '{}');

    return {
      viewed: Array.isArray(parsed.viewed) ? parsed.viewed : [],
      shown: Array.isArray(parsed.shown) ? parsed.shown : [],
      count: Number(parsed.count),
    };
  } catch (error) {
    console.debug('kl-selling-fast: the stored history could not be read, starting fresh', { error });
    return { viewed: [], shown: [], count: 0 };
  }
}

function writeState(store, state) {
  try {
    store.setItem(KL_SELLING_FAST_STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.debug('kl-selling-fast: the history could not be saved', { error });
  }
}

function hideBadge(element) {
  element.addEventListener(
    'animationend',
    () => {
      element.classList.remove(KL_SELLING_FAST_VISIBLE_CLASS, KL_SELLING_FAST_LEAVING_CLASS);
    },
    { once: true },
  );

  element.classList.add(KL_SELLING_FAST_LEAVING_CLASS);
}

function initSellingFast(element) {
  if (!element || element.dataset.klSellingFastReady === 'true') return;

  const productId = element.dataset.klSellingFastProduct;

  if (!productId) {
    console.debug('kl-selling-fast: the badge has no product to count');
    return;
  }

  element.dataset.klSellingFastReady = 'true';

  const store = getStore(element.dataset.klSellingFastStorage);

  if (!store) return;

  const state = readState(store);
  const { position, viewedIds, count } = getProductPosition(state, productId);
  const isDue = getIsBadgeDue(position, state.shown, productId);

  writeState(store, {
    viewed: viewedIds,
    shown: isDue ? [...state.shown, String(productId)].slice(-KL_SELLING_FAST_MAX_TRACKED) : state.shown,
    count: count,
  });

  if (!isDue) return;

  element.classList.add(KL_SELLING_FAST_VISIBLE_CLASS);

  setTimeout(() => hideBadge(element), parseDuration(element.dataset.klSellingFastDuration));
}

document.querySelectorAll(KL_SELLING_FAST_SELECTOR).forEach(initSellingFast);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll(KL_SELLING_FAST_SELECTOR).forEach(initSellingFast);
});
